import { Provider } from '../generated/src/models';
import { GlobalState } from './app/AppWrapper';
import { format } from 'date-fns';

export const getProvider = (globalState: GlobalState, providerName?: string) => {
  if (
    providerName &&
    globalState &&
    globalState.data &&
    globalState.data.extractionbuilderdata &&
    globalState.data.extractionbuilderdata.providers
  ) {
    const providers = globalState.data.extractionbuilderdata.providers;
    return providers.find((p: Provider) => p.name === providerName);
  }
  return undefined;
};

// Returns YYYY-MM-DD format from a Date instance.
// Optional separator, default "-".
export function toYYYYMMDD(date: Date, sep = '-'): string {
  const _m = String(date.getMonth() + 1);
  const m = _m.length < 2 ? 0 + _m : _m;
  const _d = String(date.getDate());
  const d = _d.length < 2 ? 0 + _d : _d;
  return `${date.getFullYear()}${sep}${m}${sep}${d}`;
}

export function getDateFormatString() {
  const formatObj = new Intl.DateTimeFormat(navigator.languages[0]).formatToParts(new Date());

  return formatObj
    .map(obj => {
      switch (obj.type) {
        case 'day':
          return 'dd';
        case 'month':
          return 'mm';
        case 'year':
          return 'yyyy';
        case 'literal':
          return '-';
        default:
          return obj.value;
      }
    })
    .join('');
}

export enum EDateScopes {
  START = 'Start',
  END = 'End',
}

export const isDateInRangeAndValid = (type: string, start: Date, end: Date, range: string) => {
  if (
    (type === EDateScopes.START && isNaN(new Date(start).getTime())) ||
    (type === EDateScopes.START && new Date(start).getTime() > new Date(end).getTime()) ||
    (type === EDateScopes.START && new Date(start).getTime() < new Date(range).getTime())
  ) {
    return true;
  } else if (
    (type === EDateScopes.END && isNaN(start.getTime())) ||
    (type === EDateScopes.END && start.getTime() < end.getTime()) ||
    (type === EDateScopes.END && start.getTime() > new Date(range).getTime())
  ) {
    return true;
  } else {
    return false;
  }
};

export const isDateValid = (current: Date, min: Date, max: Date) => {
  if (
    isNaN(new Date(current).getTime()) ||
    new Date(min).getTime() > new Date(current).getTime() ||
    new Date(max).getTime() < new Date(current).getTime()
  ) {
    return true;
  } else {
    return false;
  }
};

export const customDateTimeFormat = (date: Date | number) => {
  return format(date, "yyyy-MM-dd'T'HH:mm:ss")
}
